// External
import React from 'react';

// Internal
import ScheduleOnlineSetupContainer from 'features/settings/scheduleOnline/containers/ScheduleOnlineSetup';

const ScheduleOnlineSetup = () => <ScheduleOnlineSetupContainer />;

export default ScheduleOnlineSetup;
